module.exports = __webpack_public_path__ + "static/media/Ex3-S2-AV-7.5cdc6ccd.PNG";